// extracted by mini-css-extract-plugin
export default {"container":"BpsAdminDashboard_container__tfvhc","title":"BpsAdminDashboard_title__mepVJ","subtitle":"BpsAdminDashboard_subtitle__dedgG"};